export default "__VITE_ASSET__33b3fdfd__"